<div id="white-listing" class="white-listing-cls">
    <div class="display-in-center bil-top-padding-20">
        <img src="../../assets/images/failed-circle.svg" />
    </div>
    <div class="display-in-center bil-top-padding-20 bil-font-regular-large bil-font-weight">
        <span>Thank you for your interest.</span>
    </div>
    <div class="display-in-center bil-top-padding-10 bil-font-regular-large bil-text-align">
        <span>
            Unfortunately, your application does not meet our eligibility criteria.
        </span>
    </div>
    <div class="display-in-center bil-top-padding-30">
        <button mat-raised-button color="primary" (click)="onClose()">Close</button>
    </div>
</div>